import type { FamilyConditionRow as FamilyConditionRowData } from '@liza/fhir-utils';
import { useTranslation } from 'react-i18next';
import { FamilyHistoryFactItem } from './FamilyHistoryFactItem';
import { FamilyHistoryGroupRow } from './FamilyHistoryGroupRow';
import { type FamilyHistoryItemProps, relativeLine } from './familyHistoryRows';
import { relativeLabel } from './familyMemberHistoryUtils';

export type FamilyConditionRowProps = FamilyHistoryItemProps & { row: FamilyConditionRowData };

/** One condition and the relatives who have it, expanding to a selectable row per relative. */
export const FamilyConditionRow = ({ row, ...itemProps }: FamilyConditionRowProps): React.ReactElement => {
  const { t } = useTranslation('records');
  return (
    <FamilyHistoryGroupRow
      title={row.condition.label}
      description={row.facts.map((fact) => relativeLine(fact, t)).join(', ')}
      ariaLabel={t('showFamilyMemberRecords', { name: row.condition.label })}
      testId={`family-condition-${row.condition.key}`}
      recordIds={row.facts.flatMap((fact) => fact.sources.map((s) => s.record.id))}
      selectedId={itemProps.selectedFamilyMemberId}
    >
      {row.facts.map((fact) => (
        <FamilyHistoryFactItem
          key={fact.relative.key}
          fact={fact}
          title={relativeLabel(fact.relative.slot, t)}
          {...itemProps}
        />
      ))}
    </FamilyHistoryGroupRow>
  );
};
